export default {
  "ORDER_ROUTING_APP_VIEW": "ORDER_ROUTING_APP_VIEW"
}